<template>
  <a-drawer width="50%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-row :gutter="12">
        <a-col :span="10">
          <a-form-model-item label="头像" prop="avatar">
            <a-upload
              :customRequest="fileUploadRequest"
              list-type="picture-card"
              :showUploadList="false"
              :beforeUpload="beforeUpload"
              @change="handleChange">
              <img v-if="form.avatar" :src="form.avatar" alt="图片" style="height:104px;max-width:300px"/>
              <div v-else>
                <a-icon :type="uploadLoading ? 'loading' : 'plus'"/>
                <div class="ant-upload-text">上传</div>
              </div>
            </a-upload>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="12">
        <a-col :span="10">
          <a-form-model-item label="姓名" prop="realName">
            <a-input v-model="form.realName" placeholder="请输入"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="10">
          <a-form-model-item label="身份证号" prop="idCard">
            <a-input v-model="form.idCard" placeholder="请输入"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="12">
        <a-col :span="10">
          <a-form-model-item label="出生年月" prop="birthday">
            <a-date-picker
              style="width: 80%"
              v-model="form.birthday"
              format="YYYY-MM-DD"
              allow-clear/>
          </a-form-model-item>
        </a-col>
        <a-col :span="10">
          <a-form-model-item label="邮箱" prop="email">
            <a-input v-model="form.email" placeholder="请输入"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="12">
        <a-col :span="10">
          <a-form-model-item label="手机号" prop="mobile">
            <a-input v-model="form.mobile" placeholder="请输入"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="10">
          <a-form-model-item label="地区" prop="district">
            <a-input v-model="district" placeholder="请输入"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="12">
        <a-col :span="10">
          <a-form-model-item label="学历" prop="education">
            <a-select v-model="form.education" placeholder="请选择">
              <a-select-option :value="1">高中</a-select-option>
              <a-select-option :value="2">大专</a-select-option>
              <a-select-option :value="3">本科</a-select-option>
              <a-select-option :value="4">研究生</a-select-option>
              <a-select-option :value="5">博士生</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="10">
          <a-form-model-item label="性别" prop="sex">
            <a-select v-model="form.sex" placeholder="请选择">
              <a-select-option :value="0">保密</a-select-option>
              <a-select-option :value="1">男</a-select-option>
              <a-select-option :value="2">女</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="12">
        <a-col :span="10">
          <a-form-model-item label="籍贯" prop="nativePlace">
            <a-input v-model="form.nativePlace" placeholder="请输入"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="10">
          <a-form-model-item label="民族" prop="nation">
            <a-input v-model="form.nation" placeholder="请输入"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="12">
        <a-col :span="10">
          <a-form-model-item label="身高（CM）" prop="height">
            <a-input-number :step="1" v-model="form.height" placeholder="请输入"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="10">
          <a-form-model-item label="体重（kg）" prop="weight">
            <a-input-number :step="1" v-model="form.weight" placeholder="请输入"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="12">
        <a-col :span="10">
          <a-form-model-item label="是否有纹身" prop="hasTattoo">
            <a-select v-model="form.hasTattoo" placeholder="请选择">
              <a-select-option :value="0">否</a-select-option>
              <a-select-option :value="1">是</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="10">
          <a-form-model-item label="是否残疾" prop="isDisability">
            <a-select v-model="form.isDisability" placeholder="请选择">
              <a-select-option :value="0">否</a-select-option>
              <a-select-option :value="1">是</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="12">
        <a-col :span="10">
          <a-form-model-item label="残疾详情" prop="disabilityDetail">
            <a-textarea :row="3" v-model="form.disabilityDetail" placeholder="请输入" :disabled="form.isDisability == 0" />
          </a-form-model-item>
        </a-col>
        <a-col :span="10">
          <a-form-model-item label="渠道来源" prop="sourceChannel">
            <a-select v-model="form.sourceChannel" placeholder="请选择">
              <a-select-option v-for="(channel,index) in sourceChannelList" :key="index" :value="channel.id">
                {{ channel.content }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="12">
        <a-col :span="10">
          <a-form-model-item label="微信号" prop="wxCode">
            <a-input v-model="form.wxCode" placeholder="请输入" />
          </a-form-model-item>
        </a-col>
        <a-col :span="10">
          <a-form-model-item label="微信二维码地址" prop="wxCodeUrl">
            <a-upload
              :customRequest="fileUploadRequest"
              list-type="picture-card"
              :showUploadList="false"
              :beforeUpload="beforeUpload"
              @change="handleChange1">
              <img v-if="form.wxCodeUrl" :src="form.wxCodeUrl" alt="图片" style="height:104px;max-width:300px"/>
              <div v-else>
                <a-icon :type="uploadLoading ? 'loading' : 'plus'"/>
                <div class="ant-upload-text">上传</div>
              </div>
            </a-upload>
          </a-form-model-item>
        </a-col>
      </a-row>

      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getUser, updateUser, querySourceChannelList } from '@/api/biz/user'
import UploadFileToOSS from '@/utils/upload-file-to-oss'

export default {
  name: 'AddUserForm',
  props: {
    sexOptions: {
      type: Array
    },
    isNoticeOptions: {
      type: Array
    },
    statusOptions: {
      type: Array
    }
  },
  components: {
  },
  data() {
    return {
      previewImage: '',
      previewVisible: false,
      submitLoading: false,
      uploadLoading: false,
      uploading: false,
      fileList: [],
      formTitle: '',
      activeKey: '1',
      sourceChannelList: [],
      disabledUser1: false,
      disabledUser2: false,
      disabledUser3: false,
      district: null,
      // 表单参数
      form: {
        avatar: null,
        realName: null,
        email: null,
        idCard: null,
        birthday: null,
        wxCode: null,
        mobile: null,
        education: null,
        sex: null,
        workId: null,
        nativePlace: null,
        nation: null,
        height: null,
        weight: null,
        hasTattoo: null,
        isDisability: null,
        disabilityDetail: null,
        sourceChannel: null,
        topUserId: null,
        referralsUserId: null,
        topReferralsUserId: null,
        companyId: null,
        postId: null,
        resumeUrl: null,
        oneTagIds: null,
        twoTagIds: null,
        createTime: null,
        remark: null
      },
      open: false,
      rules: {
        mobile: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        idCard: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        realName: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        avatar:[
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        sourceChannel: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        email: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {},
  created() {
  },
  computed: {},
  watch: {},
  mounted() {
  },
  methods: {
    async handlePreview() {
      this.previewImage = this.form.wxCodeUrl
      this.previewVisible = true
    },
    handleCancel() {
      this.previewVisible = false
    },
    querySourceChannelList() {
      const param = {}
      querySourceChannelList(param).then(response => {
        this.sourceChannelList = response.data
      })
    },
    handleChange(info) {
      if (info.file.status === 'uploading') {
        this.uploadLoading = true
        return
      }
      if (info.file.status === 'done') {
        this.uploadLoading = false
        this.form.avatar = info.file.originFileObj.ossUrl
      }
    },
    fileUploadRequest(fileInfo) {
      this.uploadLoading = true
      new UploadFileToOSS([fileInfo.file], {
        finally: (res) => {
          // Log.info('multi-img-upload', res);
          const ossUrl = res[0].url
          fileInfo.file.ossUrl = ossUrl
          fileInfo.file.ossName = ossUrl
          fileInfo.onSuccess()
        }
      })
    },
    handleChange1(info) {
      if (info.file.status === 'uploading') {
        this.uploadLoading = true
        return
      }
      if (info.file.status === 'done') {
        this.uploadLoading = false
        this.form.wxCodeUrl = info.file.originFileObj.ossUrl
      }
    },
    beforeUpload: function (file) {
      return new Promise((resolve, reject) => {
        if (file.size > 5 * 1024 * 1000) {
          this.$message.warning('图片大小不能超过5M')
          return reject(false)
        }

        var fileType = file.type
        if (fileType.indexOf('image') < 0) {
          this.$message.warning('请上传图片')
          return reject(false)
        }
        resolve(true)
      })
    },
    onClose() {
      this.open = false
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset() {
      this.tagList = []
      this.fileList = []
      this.disabledUser1 = false
      this.disabledUser2 = false
      this.disabledUser3 = false
      this.form = {
        avatar: null,
        nickname: null,
        idCard: null,
        birthday: null,
        wxCode: null,
        mobile: null,
        education: null,
        sex: null,
        workId: null,
        nativePlace: null,
        nation: null,
        height: null,
        weight: null,
        hasTattoo: null,
        isDisability: null,
        disabilityDetail: null,
        sourceChannel: null,
        topUserId: null,
        referralsUserId: null,
        topReferralsUserId: null,
        companyId: null,
        postId: null,
        interviewTime: null,
        isReferralsTake: 0,
        resumeUrl: null,
        createTime: null,
        remark: null
      }
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd(record) {
      this.reset()
      this.querySourceChannelList()
      this.open = true
      this.formTitle = '修改app账号信息'
      getUser({ 'id': record.userId }).then(response => {
        this.form = response.data
        if (this.form.birthday) {
          this.form.birthday = this.form.birthday.substring(0, 10)
        }
        this.district = this.form.province + '' + this.form.city + '' + this.form.county
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          updateUser(this.form).then(response => {
            this.$message.success(
              '修改成功',
              3
            )
            this.open = false
            this.$emit('ok')
          }).finally(() => {
            this.submitLoading = false
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.button-wrapper {
  display: flex;
  justify-content: flex-end;
}
</style>
